import Vue from 'vue'
import TimeAgo from 'javascript-time-ago'
//import en from 'javascript-time-ago/locale/en'
var locale = require('relative-time-format/locale/en')
//import th from 'javascript-time-ago/locale/th'

TimeAgo.addLocale({
	locale: locale.locale,
	// Standard styles.
	long: locale.long,
	short: locale.short,
	narrow: locale.narrow,
	// Additional styles.
	'short-time': require('javascript-time-ago/locale-more-styles/en/short-time.json'),
	// 'short-convenient': require('javascript-time-ago/locale-more-styles/en/short-convenient.json'),
	'long-time': {
		'year': {
			'one': '{0} ปี',
			'other': '{0} ปี'
		},
		'month': {
			'one': '{0} เดือน',
			'other': '{0} เดือน'
		},
		'week': {
			'one': '{0} สัปดาห์',
			'other': '{0} สัปดาห์'
		},
		'day': {
			'one': '{0} วัน',
			'other': '{0} วัน'
		},
		'hour': {
			'one': '{0} ชั่วโมง',
			'other': '{0} ชั่วโมง'
		},
		'minute': {
			'one': '{0} นาที',
			'other': '{0} นาที'
		},
		'second': {
			'one': '{0} วินาที',
			'other': '{0} วินาที'
		},
		'now': {
			'future': 'ที่ผ่านมา',
			'past': 'ตอนนี้'
		}
	},
	// 'long-convenient': require('javascript-time-ago/locale-more-styles/en/long-convenient.json'),
	// 'tiny': require('javascript-time-ago/locale-more-styles/en/tiny.json'),
	// Quantifier.
	quantify: locale.quantify
})
//TimeAgo.addLocale(th)
//TimeAgo.setDefaultLocale('th')

// const timeAgo = new TimeAgo('th-TH')
const timeAgo = new TimeAgo('en-EN')

Vue.prototype.timeAgo = (datetime) => {
	if (!datetime)
		return '...'

	datetime = datetime.replace(' ', 'T') + '.000Z'
	let timestamp = new Date(datetime).getTime()
	timestamp = timestamp - 7 * 60 * 60 * 1000 // Timezone Asia/Bangkok
	return timeAgo.format(timestamp, 'time')
}
